import styled from 'styled-components';
import { DisplayOrder } from '../DisplayOrder';

export const Wrapper = styled.div`
  background: black;
  display: flex;
  align-items: flex-end;
  height: 100%;
  width: 100%;
  justify-content: center;
  position: absolute;
  top: 0;
  z-index: ${DisplayOrder.DarkMode};
`;

export const IconContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 36px;
`;
